import { createGetParticipantActionsLog } from 'api/participants/participants.actions';
import { ParticipantActionsLog } from './ParticipantActionsLog';
import { withCallApi } from 'components/withCallApi/withCallApi';

export const ParticipantActionsLogContainer = withCallApi({
  action: createGetParticipantActionsLog,
  // @ts-ignore
})(ParticipantActionsLog);
